import { useUnloadingOrders } from "api/wms/hooks";
import { UnloadingDetails, UnloadingLineItem, UnloadingStatus } from "api/wms/models";
import { Table } from "components/miloDesignSystem/molecules/table";
import { comfortableListUiSchema } from "components/miloDesignSystem/molecules/table/uiSchemas";
import { RightPanelSection } from "components/utils/drawer";
import { cx } from "utilities";
import { useLineItemsColumns } from "./useLineItemsColumns";
import styles from "pages/wms/shared/Wms.module.css";
import { useFilters } from "hooks/useFilters";
import { useStateModal } from "hooks";
import { UUID } from "api/types";
import { LineItemsDetailsModal } from "./lineItemsDetailsModal/LineItemsDetailsModal";

interface Props {
  unloading: UnloadingDetails;
}

export const OrdersSection = ({ unloading }: Props) => {
  const { searchParams, setFilter } = useFilters({ page: 1, unloading: unloading.id });
  const { data: orders, error, isLoading, isPreviousData, pagination } = useUnloadingOrders(
    searchParams,
  );
  const columns = useLineItemsColumns();
  const lineItemDetailsModal = useStateModal<UUID>();

  return (
    <>
      <RightPanelSection title="Zamówienia">
        <div className="pb-3">
          <Table<UnloadingLineItem>
            rows={orders}
            columns={columns}
            onPaginationChange={paginationState => setFilter("page", paginationState.pageIndex)}
            isLoading={isLoading || isPreviousData}
            error={error}
            uiSchema={comfortableListUiSchema}
            pagination={(pagination?.count || 0) > 30 ? pagination : undefined}
            onRowClick={rowId => lineItemDetailsModal.open(String(rowId))}
            overrides={row => {
              return {
                row: {
                  className: cx("cursor-pointer", {
                    [styles.cancelledItem]: row.isCancelled,
                    [styles.finishedItem]:
                      row.status === UnloadingStatus.FINISHED && !row.isCancelled,
                    [styles.inProgressItem]:
                      row.status === UnloadingStatus.IN_PROGRESS && !row.isCancelled,
                  }),
                },
              };
            }}
          />
        </div>
      </RightPanelSection>
      {lineItemDetailsModal.isOpen && lineItemDetailsModal.state && (
        <LineItemsDetailsModal
          close={lineItemDetailsModal.close}
          lineItemId={lineItemDetailsModal.state}
          unloading={unloading}
        />
      )}
    </>
  );
};
